var jade = require("/opt/actions-runner/_work/DI-Plan-Go-web/DI-Plan-Go-web/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

var jade_indent = [];
buf.push("\n<form ng-submit=\"saveRoutePlan(editRoutePlan)\" name=\"form\">\n  <div class=\"row\">\n    <calendar date=\"editRoutePlan.date\"></calendar>\n    <div class=\"select\">\n      <select ng-options=\"distrNo as t('distrNo'+distrNo) for distrNo in [0, 1, 2, 3, 4, 5]\" ng-model=\"editRoutePlan.distrNo\"></select>\n    </div>\n  </div>\n  <div ng-if=\"showCompany\" class=\"row\">\n    <div class=\"select company-select\">\n      <select ng-options=\"company.id as company.name for company in settings.companies | orderBy:'name'\" ng-model=\"editRoutePlan.companyId\" required></select>\n    </div>\n  </div>\n  <div class=\"row\">\n    <input type=\"text\" ng-model=\"editRoutePlan.name\" placeholder=\"{{ t('planModalName') }}\">\n  </div>\n  <div class=\"row\">\n    <div class=\"flex-padding\"></div>\n    <button type=\"submit\" ng-disabled=\"form.$invalid\" class=\"action\">{{ t('cSave') }}</button>\n  </div>\n</form>");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/html/templates/editRoutePlan.jade
 ** module id = 81
 ** module chunks = 1
 **/